import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { environment } from "src/environments/environment";
import { UserService } from "../services/user.service";

@Component({
  selector: "app-microsoft-callback",
  templateUrl: "./microsoft-callback.component.html",
  styleUrls: ["./microsoft-callback.component.css"],
})
export class MicrosoftCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private session: AuthService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    const session = this.route.snapshot.queryParamMap.get("session");

    const error = this.route.snapshot.queryParamMap.get("error");

    if (error) {
      this.handleError(error);
      return;
    }

    if (error || !session) {
      window.location.href = `${environment.apiBase}/accounts/microsoft/login/`;
      return;
    }

    try {
      const data = JSON.parse(atob(session));
      const token = data.token;
      this.userService.getByToken(token).subscribe({
        next: (resp) => {
          const json: any = { token: token, user: resp };

          const authSerialice = JSON.stringify(json);

          localStorage.setItem(
            this.session.sessionStorage,
            btoa(authSerialice),
          );

          const redirectUrl = localStorage.getItem("redirect_url") || "/";
          localStorage.removeItem("redirect_url");

          this.router.navigate([redirectUrl]);
        },
        error: (resp) => {
          window.location.href = `/login/?error=${resp}`;
        },
      });
    } catch (e) {
      window.location.href = `${environment.apiBase}/accounts/microsoft/login/`;
    }
  }

  private handleError(error: string) {
    // Puedes mapear mensajes si quieres
    const errorMap: any = {
      unauthorized: "Usuario no autorizado",
      not_found: "Usuario no registrado",
      ms_error: "Error con Microsoft",
      no_claims: "No se pudo obtener información del usuario",
      no_email: "No se recibió correo del usuario",
      invalid_state: "Error de sesión",
      internal_error: "Error interno",
    };

    const message = errorMap[error] || "Error desconocido";

    window.location.href = `/login/?error=${encodeURIComponent(message)}`;
  }
}
